import VideoPlayer from '../shared/videoPlayer';
import { setCookie, getCookie } from '../shared/cookieHelper';

const listNLockVideoGenerationTimeout = 300; //in seconds

$(function () {
    if ($('#test_page').length) {
        $(document).ready(function () {
            var $loading = $('#ll_loading-div').hide();
            var button = $('#attach-button');
            var input = $('#attach-input');
            var form = new FormData();
            form.append("loan-number", $("#loan-number").val());
          
            var loc1 = getCookie("ll_prefix_url");
          
            function PostData(url, data) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: false,
                    processData: false,
                    data: data,
                    beforeSend: function () {
                        $('#instructions-div p').removeClass('upload-error');
                        $('#instructions-social-div p').removeClass('upload-error');

                        $('[download="CustomVideo"], [download="VideoQRCode"]').parent().addClass('d-none');
                        $('#instructions-div p').text('Please wait while we generate your customized property video. It might take up to 5 minutes');
                        $('#instructions-div').removeClass('d-none');

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').addClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').removeClass('d-none');

                        $('[download="SocialVideo"]').parent().addClass('d-none');
                        $('#instructions-social-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social-div').removeClass('d-none');

                        $('#social_video_placeholder, #social_video').addClass('d-none');
                        $('#social_video_loading').removeClass('d-none');

                        $('[download="SocialAdVideo"]').parent().addClass('d-none');
                        $('#instructions-social_ad-div p').text('Please wait while we generate your social video. It might take up to 5 minutes');
                        $('#instructions-social_ad-div').removeClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').addClass('d-none');
                        $('#social_ad_video_loading').removeClass('d-none');

                        $('#listing_image').prop('src', 'https://cloud.cmgfi.com/dvbdysuf5/image/upload/CMG_Web_Resources/Shared_Images/ll-loading.gif');
                    },
                    success: function (result) {
                        if (result.success) {
                            window.location.href = window.location.origin + window.location.pathname + '?id=' + $("#loan-number").val();
                            return;
                        }

                        console.log(result.error);

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    },
                    error: function (xhr, status, error) {
                        console.log("status: " + status + ' error: ' + error + ' xhr:' + JSON.stringify(xhr));

                        if (xhr.status === 504) {
                            location.reload();
                            return;
                        }

                        $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                        $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                        $('#listing_image').prop('src', $('#listing_image').data('backup-src'))

                        $('#property_video_placeholder, #property_video, #property_video_qr_placeholder, #property_video_qr').removeClass('d-none');
                        $('#property_video_loading, #property_video_qr_loading').addClass('d-none');

                        $('#social_video_placeholder, #social_video').removeClass('d-none');
                        $('#social_video_loading').addClass('d-none');

                        $('#social_ad_video_placeholder, #social_ad_video').removeClass('d-none');
                        $('#social_ad_video_loading').addClass('d-none');
                    }
                });
            }

            button.on('click', function (e) {
                e.preventDefault();
                input.click();
            });

            $('#attach-input').on('change', function (e) {
                var data = new FormData();
                data.append("loan-number", $("#hdnConfirmationNumber").val());

                var files = e.target.files;
                for (var i = 0; i < files.length; i++) {
                    data.append(files[i].name, files[i]);
                }

                PostData(window.location.origin + window.location.pathname + '/upload-listing-image', data);
            })          
 
            if ($('#property_video').is('.pending')) {
                var propertyVideoStatusCounter = 0;
                var propertyVideoCompleted = false;

                var propertyVideoTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=property")
                        .done(function (data, textStatus, jqXHR) {

                            if (data.videoUrl && data.videoUrl.length > 0) {
                                
                                propertyVideoCompleted = true;

                                $('#property_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#property_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#property_video').removeClass('pending');
                                $('#property_video_loading').addClass('d-none');
                                $('[download="CustomVideo"]').attr('href', data.videoFile);
                                $('[download="CustomVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#property_video_qr').removeClass('d-none');
                                $('#property_video_qr_loading').addClass('d-none');

                                $('[download="VideoQRCode"]').attr('href', data.qrFile);
                                $('[download="VideoQRCode"]').parent().removeClass('d-none');

                                $('#instructions-div').addClass('d-none');
                                clearInterval(propertyVideoTimer);
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            console.log("Property video status check failed - status: " + textStatus + ' error: ' + errorThrown + ' xhr:' + JSON.stringify(jqXHR));
                        })
                        .always(function () {
                            if (!propertyVideoCompleted) {
                                propertyVideoStatusCounter++;

                                if (propertyVideoStatusCounter > listNLockVideoGenerationTimeout) {
                                    $('#instructions-div p').text('Unable to generate customized video.Please try again.').addClass('upload-error');
                                    clearInterval(propertyVideoTimer);
                                }
                            }                            
                        });
                }, 1000);
            }

            if ($('#social_video').is('.pending')) {
                var socialVideoStatusCounter = 0;
                var socialVideoCompleted = false;

                var socialVideoTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=social")
                        .done(function (data, textStatus, jqXHR) {

                            if (data.videoUrl && data.videoUrl.length > 0) {

                                socialVideoCompleted = true;

                                $('#social_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#social_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#social_video').removeClass('pending');
                                $('#social_video_loading').addClass('d-none');
                                $('[download="SocialVideo"]').attr('href', data.videoFile);
                                $('[download="SocialVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#instructions-social-div').addClass('d-none');
                                clearInterval(socialVideoTimer);
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            console.log("Social video status check failed - status: " + textStatus + ' error: ' + errorThrown + ' xhr:' + JSON.stringify(jqXHR));
                        })
                        .always(function () {

                            if (!socialVideoCompleted) {
                                socialVideoStatusCounter++;

                                if (socialVideoStatusCounter > listNLockVideoGenerationTimeout) {
                                    $('#instructions-social-div p').text('Unable to generate social video.Please try again.').addClass('upload-error');
                                    clearInterval(socialVideoTimer);
                                }
                            }
                          
                        });
                }, 1000);
            }

            if ($('#social_ad_video').is('.pending')) {
                var socialAdVideoStatusCounter = 0;
                var socialAdVideoCompleted = false;

                var socialAdVideoTimer = setInterval(() => {
                    $.get("/list-n-lock/video-upload-status?confirmation=" + $('#hdnConfirmationNumber').val() + "&type=social_ad")
                        .done(function (data, textStatus, jqXHR) {

                            if (data.videoUrl && data.videoUrl.length > 0) {
                                
                                socialAdVideoCompleted = true;

                                $('#social_ad_video [data-role="thumbnail"]').attr('data-src', data.previewURL);
                                $('#social_ad_video [data-role="play-button"]').attr('href', data.videoUrl);
                                $('#social_ad_video').removeClass('pending');
                                $('#social_ad_video_loading').addClass('d-none');
                                $('[download="SocialAdVideo"]').attr('href', data.videoFile);
                                $('[download="SocialAdVideo"]').parent().removeClass('d-none');
                                new VideoPlayer();

                                $('#instructions-social_ad-div').addClass('d-none');
                                clearInterval(socialAdVideoTimer);
                            }
                        })
                        .fail(function (jqXHR, textStatus, errorThrown) {
                            console.log("Social Ad video status check failed - status: " + textStatus + ' error: ' + errorThrown + ' xhr:' + JSON.stringify(jqXHR));
                        })
                        .always(function () {

                            if (!socialAdVideoCompleted) {
                                socialAdVideoStatusCounter++;

                                if (socialAdVideoStatusCounter > listNLockVideoGenerationTimeout) {
                                    $('#instructions-social_ad-div p').text('Unable to generate social ad video.Please try again.').addClass('upload-error');
                                    clearInterval(socialAdVideoTimer);
                                }
                            }                           
                        });
                }, 1000);
            }
        });
    }
});